'use strict';

const APP_MODE = {
    0x00: 'NONE',
    0x01: 'USSD',
    0x02: 'TCP',
    0x03: 'UDP',
    0x04: 'AWS',
    0x05: 'URSALINK_CLOUD',
};

function parse(reader) {
    reader.readUInt8('data.params', value => APP_MODE[value]);
}

module.exports.parse = parse;



// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/mode/cloud/v1_3/common/rule/app-mode-parser.js